import { DocumentWorkflowTemplateType, SignatureType } from '@dealstack/shared/lib/generated';
import { getSignatureTypeVisibility } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/utils/getSignatureTypeVisibility';
import { supportsWitnessField } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ProgrammeSettings/MasterDocuments/utils/supportsWitnessField';

export type FieldVisibility = {
	show: boolean;
	locked?: boolean;
	lockedValue?: SignatureType;
};

export type FieldVisibilityKey =
	| 'name'
	| 'type'
	| 'classifiers'
	| 'visibleIn'
	| 'signatureType'
	| 'counterparties'
	| 'witnessRequired'
	| 'individualScheduleRequired'
	| 'individualInstances'
	| 'instruction';

export type FieldVisibilityMap = Record<FieldVisibilityKey, FieldVisibility>;

const HIDDEN: FieldVisibility = { show: false };
const SHOWN: FieldVisibility = { show: true };

export const getFieldVisibility = ({
	type,
	signatureType,
	individualInstances,
}: {
	type: DocumentWorkflowTemplateType;
	signatureType: SignatureType;
	individualInstances: boolean;
}): FieldVisibilityMap => {
	const isSignatureRequired = type === DocumentWorkflowTemplateType.SIGNATURE_REQUIRED;
	const witnessSupported = supportsWitnessField({ signatureType, individualInstances });

	return {
		name: SHOWN,
		type: SHOWN,
		classifiers: SHOWN,
		visibleIn: SHOWN,
		signatureType: getSignatureTypeVisibility(type),
		counterparties: isSignatureRequired ? SHOWN : HIDDEN,
		witnessRequired: isSignatureRequired && witnessSupported ? SHOWN : HIDDEN,
		individualScheduleRequired: SHOWN,
		individualInstances: isSignatureRequired ? SHOWN : HIDDEN,
		instruction: SHOWN,
	};
};
